<template>
  <v-form ref="form" @submit.prevent="saveForm">
    <LocomotiveFieldFactory
      v-model="locomotiveNumbers"
      name="locomotive-number"
      label="Numery lokomotyw"
      :companyId="this.serviceCompany.id"
      :icon="null"
      multiple
      :rules="[required]"
    />
    <DialogSaveButton type="submit" style="padding-left: 0 !important; padding-right: 0 !important" />
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';
import LocomotiveFieldFactory from '@/component/Field/Locomotive/locomotive-field-factory';
import DialogSaveButton from '@/component/Dialog/dialog-save-button';
import { SERVICE_TYPE_DICT } from '@/core/dict/service-type-dict';
import { cloneDeep } from 'lodash';

export default {
  name: 'SupplementingMaterials',
  components: {
    LocomotiveFieldFactory,
    DialogSaveButton,
  },
  props: {
    entity: Object,
    company: Object,
    isAddMode: Boolean,
  },
  data() {
    return {
      locomotiveNumbers: [],
    };
  },
  created() {
    if (!this.isAddMode && this.entity) {
      this.locomotiveNumbers = cloneDeep(this.entity.locomotives);
    } else if (this.isSupplementingConsumablesAdded) {
      this.locomotiveNumbers = this.$store.getters['service/services'].find(
        ({ serviceType }) => serviceType === SERVICE_TYPE_DICT.SUPPLEMENTING_MATERIALS
      ).locomotives;
    }
  },
  computed: {
    ...mapGetters('service', ['isSupplementingConsumablesAdded']),
    serviceCompany() {
      return this.entity ? this.company : this.$store.getters['service/serviceCompany'];
    },
  },
  methods: {
    required(v) {
      return v.length > 0 || 'Wybierz przynajmniej jedną lokomotywę';
    },
    saveForm() {
      if (this.$refs.form.validate()) {
        const payload = {
          serviceType: SERVICE_TYPE_DICT.SUPPLEMENTING_MATERIALS,
          locomotives: this.locomotiveNumbers,
        };
        if (this.isAddMode) {
          this.$emit('addServiceItem', payload);
        } else if (this.entity) {
          this.$emit('editExistingServiceItem', payload);
        } else if (this.isSupplementingConsumablesAdded) {
          this.$store.dispatch('service/updateService', payload);
        } else {
          this.$store.dispatch('service/addService', payload);
        }

        this.$emit('submit');
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
